import { ApiResponse } from './api';

/**
 * The analytics crons an admin can run on demand.
 *
 * Analytics only — the outbox and Zoho crons exist in the backend's scheduler but are
 * deliberately not exposed here, and the backend rejects them independently.
 */
export enum AnalyticsCronJob {
  CompanyAnalysisDaily = 'COMPANY_ANALYSIS_DAILY',
  CompanyGroupAnalysisDaily = 'COMPANY_GROUP_ANALYSIS_DAILY',
  CompanyDepartmentAnalysisDaily = 'COMPANY_DEPARTMENT_ANALYSIS_DAILY',
  PortfolioAnalysisDaily = 'PORTFOLIO_ANALYSIS_DAILY',
  CompanyVestedUnvestedAnalysisDaily = 'COMPANY_VESTED_UNVESTED_ANALYSIS_DAILY',
  SubscribedPortfolioIndexFundDaily = 'SUBSCRIBED_PORTFOLIO_INDEX_FUND_DAILY',
  SubscribedIndexFundAggregationDaily = 'SUBSCRIBED_INDEX_FUND_AGGREGATION_DAILY',
}

export type TriggerAnalyticsCronRequest = {
  jobName: AnalyticsCronJob;
};

/**
 * What comes back when a job is started.
 *
 * `startedAt`, not `finishedAt`: the backend answers as soon as the job begins and never
 * reports its outcome, which lives in the service logs.
 */
export type TriggerAnalyticsCronResponse = ApiResponse<{
  jobName: AnalyticsCronJob;
  startedAt: string;
}>;
